import { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Sidebar } from './components/Sidebar';
import { Home } from './pages/Home';
import { NPCGeneratorPage } from './pages/NPCGeneratorPage';
import { MissionGeneratorPage } from './pages/MissionGeneratorPage';
import { LocationGeneratorPage } from './pages/LocationGeneratorPage';
import { ContentLibraryPage } from './pages/ContentLibraryPage';

const MenuIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="3" y1="12" x2="21" y2="12" />
    <line x1="3" y1="6" x2="21" y2="6" />
    <line x1="3" y1="18" x2="21" y2="18" />
  </svg>
);

const CloseIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

export const App = (): JSX.Element => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const sidebarWidth = isMobile ? (isMobileMenuOpen ? '256px' : '0px') : '256px';

  return (
    <div
      style={{
        minHeight: '100vh',
        backgroundColor: '#1a1a2e',
        color: '#e5e7eb',
        position: 'relative',
      }}
    >
      {/* Mobile Overlay */}
      {isMobile && isMobileMenuOpen && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 40,
          }}
          onClick={() => setIsMobileMenuOpen(false)}
        />
      )}

      {/* Sidebar */}
      <div
        style={{
          position: 'fixed',
          left: 0,
          top: 0,
          height: '100vh',
          width: sidebarWidth,
          zIndex: 50,
          transition: 'width 0.3s ease',
          overflow: 'hidden',
        }}
      >
        <Sidebar
          isMobile={isMobile}
          isOpen={isMobileMenuOpen}
          onClose={() => setIsMobileMenuOpen(false)}
        />
      </div>

      {/* Main Content Area */}
      <main
        className="main-content"
        style={{
          marginLeft: isMobile ? 0 : '256px',
          minHeight: '100vh',
          transition: 'margin-left 0.3s ease',
        }}
      >
        {/* Top Bar */}
        <header
          className="mobile-header"
          style={{
            height: '64px',
            backgroundColor: 'rgba(22, 22, 42, 0.8)',
            backdropFilter: 'blur(12px)',
            borderBottom: '1px solid rgba(212, 175, 55, 0.2)',
            position: 'sticky',
            top: 0,
            zIndex: 30,
            padding: isMobile ? '0 16px' : '0 32px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
            {/* Mobile Menu Button */}
            {isMobile && (
              <button
                className="mobile-menu-button"
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                style={{
                  background: 'transparent',
                  border: 'none',
                  color: '#d4af37',
                  cursor: 'pointer',
                  padding: '8px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                {isMobileMenuOpen ? <CloseIcon /> : <MenuIcon />}
              </button>
            )}
            <h2
              style={{
                color: '#d4af37',
                fontFamily: 'Cinzel, serif',
                fontWeight: 600,
                margin: 0,
                fontSize: isMobile ? '16px' : '20px',
              }}
            >
              Blades Content Generator
            </h2>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
            {!isMobile && (
              <span style={{ fontSize: '14px', color: '#9ca3af' }}>Welcome, Scoundrel</span>
            )}
            <div
              style={{
                width: '32px',
                height: '32px',
                backgroundColor: 'rgba(212, 175, 55, 0.2)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: '1px solid rgba(212, 175, 55, 0.3)',
              }}
            >
              <span style={{ color: '#d4af37', fontSize: '14px', fontWeight: 700 }}>S</span>
            </div>
          </div>
        </header>

        {/* Page Content */}
        <div className="mobile-padding" style={{ padding: isMobile ? '16px' : '32px' }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/npc-generator" element={<NPCGeneratorPage />} />
            <Route path="/mission-generator" element={<MissionGeneratorPage />} />
            <Route path="/location-generator" element={<LocationGeneratorPage />} />
            <Route path="/content-library" element={<ContentLibraryPage />} />
          </Routes>
        </div>
      </main>
    </div>
  );
};
